import React, { useState } from 'react';

interface AnnouncementModalProps {
  title: string;
  message: React.ReactNode;
}

const AnnouncementModal: React.FC<AnnouncementModalProps> = ({ title, message }) => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button style={closeButtonStyle} onClick={() => setVisible(false)}>×</button>
        <h2 style={titleStyle}>{title}</h2>
        <p style={messageStyle}>{message}</p>
      </div>
    </div>
  );
};

// Styles
const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle: React.CSSProperties = {
  backgroundColor: '#fff',
  padding: '2rem',
  borderRadius: '8px',
  maxWidth: '500px',
  width: '90%',
  textAlign: 'center',
  position: 'relative',
  boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
};

const closeButtonStyle: React.CSSProperties = {
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  background: 'none',
  border: 'none',
  fontSize: '2rem',
  fontWeight: 'bold',
  color: '#333',
  cursor: 'pointer',
  lineHeight: 1,
};

const titleStyle: React.CSSProperties = {
  margin: '0 0 1rem 0',
  fontSize: '1.5rem',
  color: '#222',
};

const messageStyle: React.CSSProperties = {
  margin: 0,
  fontSize: '1rem',
  color: '#333',
};

export default AnnouncementModal;